module.exports = __webpack_public_path__ + "static/media/location-change.a91a258b.wav";